// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-logo-logo-62e0XeeRmwr{display:flex;align-items:flex-end;white-space:nowrap}.product-logo-logo-62e0XeeRmwr>img{height:100%}.product-logo-logo-62e0XeeRmwr.product-logo-invert-2YydCY2Emwr>svg path{fill:var(--always-light-text)}", "",{"version":3,"sources":["webpack://./client/shared/product-logo/product-logo.scss"],"names":[],"mappings":"AAEA,+BACE,YAAA,CACA,oBAAA,CACA,kBAAA,CAEA,mCACE,WAAA,CAKE,wEACE,6BAAA","sourcesContent":["@import '../styles/variables.scss';\n\n.logo {\n  display: flex;\n  align-items: flex-end;\n  white-space: nowrap;\n\n  > img {\n    height: 100%;\n  }\n\n  &.invert {\n    > svg {\n      path {\n        fill: var(--always-light-text);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1faece",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#f7e28b",
	"violetLight2": "#cec0ec",
	"tealLight3": "#cfece8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"logo": "product-logo-logo-62e0XeeRmwr",
	"invert": "product-logo-invert-2YydCY2Emwr"
};
export default ___CSS_LOADER_EXPORT___;
